var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1753_10667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.81281 0 0 3.81281 0 8.5C0 13.1872 3.81281 17 8.5 17C13.1872 17 17 13.1865 17 8.5C17 3.81348 13.1872 0 8.5 0ZM8.5 15.6832C4.5397 15.6832 1.3168 12.461 1.3168 8.5C1.3168 4.53903 4.5397 1.3168 8.5 1.3168C12.4603 1.3168 15.6832 4.53903 15.6832 8.5C15.6832 12.461 12.461 15.6832 8.5 15.6832Z",
    fill: "#49712B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7923 7.78226H9.15866V5.14865C9.15866 4.78521 8.86435 4.49023 8.50025 4.49023C8.13614 4.49023 7.84183 4.78521 7.84183 5.14865V7.78226H5.20822C4.84412 7.78226 4.5498 8.07723 4.5498 8.44068C4.5498 8.80412 4.84412 9.09909 5.20822 9.09909H7.84183V11.7327C7.84183 12.0961 8.13614 12.3911 8.50025 12.3911C8.86435 12.3911 9.15866 12.0961 9.15866 11.7327V9.09909H11.7923C12.1564 9.09909 12.4507 8.80412 12.4507 8.44068C12.4507 8.07723 12.1564 7.78226 11.7923 7.78226Z",
    fill: "#49712B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1753_10667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.cdf4786613a3e54998f16dafe91cd137.svg";
export { ForwardRef as ReactComponent };